import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root',
})
export class AboutusService {
  constructor(private http: HttpClient) {}
  public getAboutUsDetails(selectedpage: any): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/' + selectedpage);
  }
  public getCultureDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/culture');
  }
  public getclimateDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/climate');
  }
  public getgeographyDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/geography');
  }
  public gethistoryDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/history');
  }
  public getsocietyDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/society');
  }
  public getCultureReligionDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/religion');
  }
  public getCultureArtDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/art');
  }
  public getCultureArchitectureDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/architecture');
  }
  public getLanguageDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/language');
  }
  public getPeopleDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/people');
  }
  public getCuisinesRecepiesDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/aboutus/cuisines-recepies');
  }

  public getAllCultureDetails(): Observable<any[]> {
    let peopleDetails = this.getPeopleDetails();
    let cultureReligionDetails = this.getCultureReligionDetails();
    let languageDetails = this.getLanguageDetails();
    return forkJoin([peopleDetails, cultureReligionDetails, languageDetails]);
  }

  /* special Intrest services */

  public getSpecialIntrestDetails(specialIntrestName: any): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/' + specialIntrestName);
  }
  public getSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/special-interest');
  }
  public getGeneralSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/nature');
  }
  public getSailingSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/sailing');
  }
  public getRomanceSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/romance');
  }
  public getSustainabilitySpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/sustainability');
  }
  public getDivingSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/diving');
  }
  public getCultureSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/culture');
  }
  public getCreoleSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/creole-rendezvous');
  }
  public getFishingSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/fishing');
  }
  public getWorkcationSpecialIntrest(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/splinterests/workcation');
  }
}
